import { useEffect, useState } from 'react';

const TICK_MS = 1000;

/** The current time, updated every second while ticking, so running timers move between polls. */
export function useNow(isTicking: boolean) {
  const [now, setNow] = useState(Date.now);

  useEffect(() => {
    if (!isTicking) {
      return undefined;
    }

    const interval = setInterval(() => setNow(Date.now()), TICK_MS);
    return () => clearInterval(interval);
  }, [isTicking]);

  return now;
}
